import React from 'react';
import { SalesPage } from './components/SalesPage';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <SalesPage data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
    </>;
}